import React, { useState, useEffect } from 'react';

function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const clientId = 'b9b7e5f2bf934e298be546311671e94e';
  const clientSecret = 'tBXUBViiawNopKFS2ds4oWYYeGsPIChxnjf4UktPMvhs6LRUelyA3vnMEEGmaOy6';

  const fetchAllegroData = async () => {
    try {
      setLoading(true);
      const tokenResponse = await fetch('https://allegro.pl/auth/oauth/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic ' + btoa(`${clientId}:${clientSecret}`)
        },
        body: 'grant_type=client_credentials'
      });

      const { access_token } = await tokenResponse.json();

      const campaignsResponse = await fetch('https://api.allegro.pl/campaigns', {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'Accept': 'application/vnd.allegro.public.v1+json'
        }
      });

      const data = await campaignsResponse.json();
      setCampaigns(data.campaigns);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllegroData();
  }, []);

  if (loading) return <div className="text-center p-4">Ładowanie kampanii...</div>;
  if (error) return <div className="text-red-500 p-4">Błąd: {error}</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6">Kampanie Allegro Ads</h1>
      
      <div className="grid gap-4">
        {campaigns.map(campaign => (
          <div key={campaign.id} className="bg-white p-4 rounded-lg shadow">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-medium">{campaign.name}</h3>
                <p className="text-sm text-gray-600">
                  Budget: {campaign.budget.amount} {campaign.budget.currency}
                </p>
                <p className="text-sm text-gray-600">
                  Status: {campaign.status}
                </p>
              </div>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                onClick={() => {/* Tu dodamy funkcję do aktualizacji statusu */}}
              >
                Zmień status
              </button>
            </div>
          </div>
        ))}
      </div>

      {campaigns.length === 0 && (
        <div className="text-center text-gray-500 p-4">
          Brak aktywnych kampanii
        </div>
      )}
    </div>
  );
}

export default Campaigns;